/** HKD / USD / CNY → async-icon sprite 名（维护 SVG：packages/www/icons/async-icon/currency-*.svg） */
const CURRENCY_SPRITE_NAMES: Record<string, string> = {
  HKD: 'currency-hk',
  USD: 'currency-us',
  CNY: 'currency-cn',
};

export function currencySpriteName(code: string): string {
  return CURRENCY_SPRITE_NAMES[String(code || '').trim().toUpperCase()] ?? '';
}

/** @deprecated 使用 currencySpriteName + CurrencyFlag 组件 */
export function currencyFlagIcon(code: string): string {
  return currencySpriteName(code);
}
